import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import convertMillisecondsToDate from "../../services/dateconverter";
import formatStringWithSpaces from "../../services/stringconverter";
import EditIcon from "@mui/icons-material/Edit";
import truncateString from "../../services/truncatestring";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import convertMillisecondsToOnlyDate from "services/converMillisecondstoDate";

export const Deficiencycolumns = [
  { name: "Deficiency Date", align: "center" },
  { name: "Deficiency PIF #", align: "center" },
  { name: "Type Of Inspection & List Of Deficiencies", align: "center" },
  { name: "Correction Date", align: "center" },
  { name: "Corrected PIF #", align: "center" },
  { name: "Action", align: "center" },
];

function Rows(data, setDialogue, projectId) {
  
  return {

    changeColor: data?.corrected_date == 0? true : false,

    "Deficiency Date": (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="regular"
        textTransform="capitalize"
        fontSize="14px"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordWrap: "break-word",
          maxWidth: "200px",
          lineHeight: "1.5em",
        }}
      >
        {data?.deficiency_date !== 0
          ? convertMillisecondsToOnlyDate(data?.deficiency_date)
          : ""}
      </SoftTypography>
    ),

    "Deficiency PIF #": (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="regular"
        textTransform="capitalize"
        fontSize="14px"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordWrap: "break-word",
          maxWidth: "200px",
          lineHeight: "1.5em",
        }}
      >
        {data?.deficiency_inspection_id?.inspection_number}-{data?.deficiency_inspection_id?.inspection_discipline_start}
      </SoftTypography>
    ),

    "Correction Date": (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="regular"
        textTransform="capitalize"
        fontSize="14px"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordWrap: "break-word",
          minWidth: "90px",
          lineHeight: "1.5em",
        }}
      >
        {data?.corrected_date !== 0
          ? convertMillisecondsToOnlyDate(data?.corrected_date)
          : ""}
      </SoftTypography>
    ),

    "Corrected PIF #": (
      <SoftTypography
        variant="text"
        color="lightBlack"
        fontWeight="regular"
        textTransform="capitalize"
        fontSize="14px"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordWrap: "break-word",
          minWidth: "90px",
          lineHeight: "1.5em",
        }}
      >
        {data?.corrected_inspection_id?.inspection_number}-{data?.corrected_inspection_id?.inspection_discipline_start}
      </SoftTypography>
    ),

    "Type Of Inspection & List Of Deficiencies": (
      <SoftBox sx={{ minWidth: "450px" }}  display="flex" flexDirection="column" alignItems="start" justifyContent="center" >
        <SoftTypography
          variant="text"
          color="lightBlack"
          fontWeight="bold"
          textTransform="capitalize"
          textAlign="left"
          fontSize="14px"
          sx={{
            display: "block",
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.5em",
            maxWidth: "465px",
          }}
        >
          {data?.inspection_type}
        </SoftTypography>


       { data?.location &&   <SoftTypography
          variant="text"
          color="lightBlack"
          fontWeight="bold"
          textTransform="capitalize"
          textAlign="left"
          fontSize="14px"
          sx={{
            display: "block",
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.5em",
            maxWidth: "465px",
          }}
        >
         Location: {data?.location}
        </SoftTypography> }


        {data?.list_of_dependencies?.length > 0 &&
          data?.list_of_dependencies.map((item, index) => (
            <SoftTypography
              variant="text"
              color="lightBlack"
              fontWeight="normal"
              textTransform="capitalize"
              textAlign="left"
              fontSize="14px"
              sx={{
                display: "block",
                whiteSpace: "normal",
                wordWrap: "break-word",
                maxWidth: "465px",
                lineHeight: "1.5em",
              }}
            >
               {item}
            </SoftTypography>
          ))}
      </SoftBox>
    ),

    Action: (
      <SoftBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={3}
        onClick={(e) => e.stopPropagation()}
      >
        <DeleteIcon
          sx={{
            cursor: "pointer",
            width: "24px",
            height: "24px",
            color: "error.main",
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDialogue({
              type: "deleteDeficiencylog",
              isOpen: true,
              deficiencylogID: data._id,
            });
          }}
        />
        <EditIcon
          onClick={() =>
            setDialogue({
              type: "AddDeficiency",
              isOpen: true,
              isEdit: true,
              deficiencylogId: data?._id,
              inspectionId: "",
              projectId: projectId,
            })
          }
          sx={{
            cursor: "pointer",
            width: "20px",
            height: "20px",
            color: "white.main",
            backgroundColor: "primary.main",
            padding: "2px",
            borderRadius: "50%",
          }}
        />
      </SoftBox>
    ),
  };
}

export default Rows;
